import Vue from 'vue'
import dayjs from 'dayjs'

Vue.use(dayjs)
